import React from 'react'
import { makeStyles } from '@mui/styles'
import lang from 'lang'
import SVGIcon from '../../svg-icon/svg-icon'
import ContextMenuItem from '../context-menu-item/context-menu-item'

import ViewIcon from '@assets/images/icons/view.svg'

const ContextMenuViewItem = (props) => {
  const { onItemClick } = props

  const classes = useStyles()
  const icon = <SVGIcon customClass={classes.svg} width="13px" height="13px" svg={ViewIcon} />

  return (
    <ContextMenuItem
      label={lang.contextMenu.show}
      icon={icon}
      onItemClick={onItemClick} />
  )
}

const useStyles = makeStyles(() => ({
  svg: {
    fill: '#757b8a',
  },
}))
export default ContextMenuViewItem
